import {
    getRechargeInfoV2,
    getAppPayInfo,
    getOrderPayStatus,
    getRechargeActivityVerify,
    getAutoPickCoupon,
} from 'root/tqcz/modules/index.js';
import service from 'root/blackcard/components/service/service.vue';
import appDownload from 'root/blackcard/components/appDownload/index';
import collect from './V2/collect.vue';
import 'root/common/util/Stat.js';
import 'root/common/gio/pv/tqcz/tqcz';
import { gioEvariableTrackOfPrivilege } from 'root/common/gio/tqGio';
import Checkbox from 'vant/lib/checkbox';
import 'vant/lib/checkbox/style';
import DisasterNoticeBar from 'root/common/components/noticeBar/noticeBar';
import Popup from 'root/common/components/popup/popup';
import { onVisibilityChange } from 'root/common/nativeApi/index';
import PrivilegeState from 'root/common/thirdParty/privilege/state';
import PrivilegeMixin from 'root/common/thirdParty/mixin/privilege';
import GameMixin from '../../mixin/game';
import AliPayStudentCert from '../../mixin/aliPayStudentCert';
import DestoryPageMixin from '../../mixin/destoryPage';
import CHANNEL from 'root/common/thirdParty/const/channel';
import reminderBanner from 'root/common/components/reminderV2/index';
import markMixins from '../../mixin/reminder.js';
import TimeDown from '../../components/timedown.vue';
import AllowanceDialog from 'root/common/components/tqDiscount/components/allowanceDialog.vue';
import AllowanceTips from 'root/common/components/giftAmounts/allowanceTips/AllowanceTipsV2.vue';
import CouponList from 'root/common/components/couponList/CouponList.vue';
import FadeInHeader from 'root/common/components/FadeInHeaderV2';
import ImmersionHead from 'root/common/components/immersionHead/immersionHead';
import MemberList from './V2/MemberList.vue';
import Tips from './V2/Tips.vue';
import storage from 'root/common/util/storage.js';
import keyConfig from 'root/common/const/localStorageKey.js';
import { getGDMobileServiceUrl } from 'root/common/util/getYunKeFu';
// import { uniPayClass } from 'root/common/uniPay';
import '../../styles/cy/index.scss';
import shareBtn from 'root/common/components/shareBtn';
import RechargeSuccessAccount from './V2/rechargeSuccessAccount.vue';
import { getQueryFromQuery } from 'root/common/util/url';
import { OrderListGrayScale } from '@/common/util/privilege';
import { flattenPrivilegeCategory } from '@/common/privilege/utils';
import { isJobConvenienceAliMini, JobConvenienceAliMiniAppId } from '@/common/util/miniEnv';
import getAdvPostions from 'root/common/mixins/getAdvPostions';
// import config from 'root/common/config/config';
// import { request } from 'root/common/request';
// import { getMiniEnvOfKey } from 'root/common/util/miniEnv';

/* 领取优惠券列表组件 */
import userGetCouponList from 'root/common/components/tqCoupon/userGetCouponList';
import memberWall from 'root/common/components/memberWall';
import env from '@/common/util/env';
import AllowanceMixin from '../../mixin/allowance';
import { shoppingUbsidyTipShowTrack, shoppingUbsidyTipClickTrack } from '../../track/index';
import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import * as nativeApi from '@/common/nativeApi/index';
import { getUtmParams } from '@/common/gio/utm';

Vue.use(VueAwesomeSwiper);

// 关掉灰度
OrderListGrayScale.on = false;

OrderListGrayScale.init();

let payTimer;
const zzc = window.zzc;
const ZZCFL = window.ZZCFL;

new PrivilegeState();

const sourceChannel = PrivilegeState.get();

if (sourceChannel) {
    // 动态引入公共组件的 UI 调整
    if (PrivilegeState.isBelongToChannel(sourceChannel, CHANNEL.CHANG_YOU)) {
        import('../../styles/cy/ui.scss');
    }
    if (PrivilegeState.isChannel(sourceChannel, CHANNEL.SC_CHANG_YOU)) {
        import('../../styles/cy/ui-sc.scss');
    }
}

let confirmDialogInstance = null;
let focusLock = false; // ? blur没有完成的时候锁住。focus在blur之后重新触发（貌似是通过传播），总之见鬼了。

export default {
    data() {
        return {
            showRewardsDescDialog: false,
            pageInfo: {},
            showRechargeSuccessAccount: false,
            isShowDel: false,
            isError: false,
            categoryIndex: 0,
            categoryDetailList: [],
            productIndex: 0,
            productActiveObj: {},
            productActiveObjTemp: null, // 暂用于活动优惠的sku
            paymentMethodData: [],
            isPaymentMethodShow: false,
            isApp: window.__is_blackApp,
            appPayTimeOut: 30,
            isAppPayCancel: false,
            query: {},
            order_id: null,
            errorTips: '',
            orderLink: '',
            isSpecial: false, // 是否含有多个供应商
            isShowService: false, // 是否显示电话弹窗
            customPhoneList: [], // 多个供应商电话
            paddingTopNum: 1,
            customPhone: '4000233086', // 客服电话
            customPhoneFormat: null,
            submitText: '立即充值',
            isStopSale: false, // 是否停止购买
            appDownload: false,
            showCollect: false,
            showBarParams: true,
            selfService: false,
            showTips: true,
            signed_account: '', // 上次办理连续包月的手机号， 商品规格返回
            lastProduct: {}, // 上一个选中的产品
            newPrice: 0,
            oldPrice: 0,
            renewPrice: 0,
            showPriceTips: false,
            submitName: null, // 按钮文案
            trackPageName: null, // 统计页面名称
            isAuto: false, // 是否包含连续包月
            tipsImage: null, // 提示图片
            // selfTelephone: false, // 是否自营
            isShowCouponList: false,
            couponList: [],
            id: '',
            showOverMask: false,
            showCouponPop: false,
            couponSku: {}, // 爱奇艺活动sku对象
            isShowFirstPop: false,
            isShowSecPop: false,
            popImg: null, // 弹窗图片
            showReminder: false,
            renewBuyInfo: null, // 是否续费专享购
            tipsIcon: require('../../images/ic_question.png'),
            isShowRenewConflict: false,
            currentCouponAmount: 0, // 当前item是不是有券后价
            currentRenewAmount: 0, // 当前item是不是有续费价
            priceAfterCoupon: 0, // 券后价
            getCouponBuyText: '用券购买',
            isCurrentPaymentCycle: false,
            isDontShowShareBtn: false,
            shareHash: storage.get('shareHash'),
            isNotMember: false,
            formatPhone: '',
            isDel: false,
            events: [{ name: '分享', event: this.share }],

            mpDownloadAppParams: {
                name: '优惠充值',
                ignore: env.isAndroid, // iOS 拦截下单
                link:
                    'https://mp.weixin.qq.com/s?__biz=MzI2Njk4MTI0OQ==&mid=100558524&idx=1&sn=71ac27b4f5ae07977a50f8b6c21cb523&chksm=6a8f1c525df895449daa779b4dd18ab1b6c57aabcb5a490c413b5bd99a8f85d1567beca55b4a#rd',
            },
            swiperOption1: {
                loop: true,
                spaceBetween: 0,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                initialSlide: 0,
                // speed: 1000,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-mine-pagination-1',
                },
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
            },
            swiperOption2: {
                loop: true,
                spaceBetween: 0,
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                initialSlide: 0,
                // speed: 1000,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-mine-pagination-2',
                },
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
            },
            isInputClose: false,
            inputType: '',
            isJobConvenienceAliMini, // 支付宝职业福利小程序
            isCheckAutoRule: false, // 包月协议勾选
            // showAutoRulePop: false,
            showRuleAnimation: false,
        };
    },
    mixins: [
        markMixins(),
        PrivilegeMixin,
        GameMixin,
        AllowanceMixin,
        getAdvPostions('recharge_detail_top_banner,recharge_detail_bottom_banner'),
        DestoryPageMixin,
        AliPayStudentCert,
    ],
    created() {
        this.init();
        if (!getQueryFromQuery(location.search).shareHash) {
            storage.remove('shareHash');
        }

        if (this.isApp) {
            onVisibilityChange(visibile => {
                if (visibile) {
                    this.init(this.skuId, visibile);
                    if (this.productActiveObjTemp) {
                        this.productActiveObj = this.productActiveObjTemp;
                    }
                    if (confirmDialogInstance && typeof ZZCFL.Dialog.close === 'function') {
                        confirmDialogInstance = null;
                        ZZCFL.Dialog.close();
                    }
                }
            });
        }

        //weixin
        if (window.__GLOBAL_WXINFO && !window.__is_blackApp) {
            const info = window.__GLOBAL_WXINFO.default_share;
            // info.link = info.link_shop_finish;
            info.link = `${window.location.origin}/?utm_source=sc&utm_medium=tequan&utm_campaign=heika&channel_hash=b61ae0df16124e511bac8e6cc5b512c5`;
            // 初始化分享配置
            ZZCFL.Utils.Share.start({
                shareInfo: info,
            });
        }
    },

    components: {
        'service-pop': service,
        'van-checkbox': Checkbox,
        appDownload,
        collect,
        RechargeSuccessAccount,
        DisasterNoticeBar,
        userGetCouponList,
        Popup,
        reminderBanner,
        TimeDown,
        shareBtn,
        memberWall,
        AllowanceDialog,
        AllowanceTips,
        CouponList,
        MemberList,
        Tips,
        FadeInHeader,
        ImmersionHead,
        // integralContainer,
    },
    computed: {
        tjData() {
            return {
                item_id: this.id,
                item_name: this.pageInfo?.product?.name,
                item_type: this.productActiveObj?.category,
                spu_id: this.id,
                spu_name: this.pageInfo?.product?.name,
                sku_id: this.productActiveObj?.id,
                sku_name: this.productActiveObj?.name,
                sku_price: this.productActiveObj?.bestPrice,
                sku_original_price: this.productActiveObj?.unit_price_old,
                link: this.productActiveObj?.jump_url,
                specification: this.productActiveObj?.spec,
                sku_no: this.productActiveObj?.sku_no,
                recharge_amount: this.productActiveObj?.bestPrice,
            };
        },
        skuId() {
            return this.productActiveObj && this.productActiveObj.id;
        },

        // 当前为续费sku状态 展示续费头图
        currentSkuIsRenewPrice() {
            return !this.isSourceChannel && this.renewBuyInfo?.product?.renewalHeadImg && !this.isCurrentPaymentCycle;
        },

        // 符合自动领券时显示券后价¥XX.XX
        hasAutoCouponStatus() {
            return (
                Number(this.currentCouponAmount) &&
                !this.isSourceChannel &&
                !this.submitName &&
                (!this.currentRenewAmount || this.currentCouponAmount > this.currentRenewAmount)
            );
        },

        currentBestPrice() {
            return this.productActiveObj.bestPrice;
        },
        isDiscountForStudent() {
            return this.productActiveObj.identityType === 1;
        },
        phone() {
            if (this.inputType === 'phone' || this.inputType === 'qq') {
                return this.formatPhone.split(' ').join('');
            }
            if (this.inputType === 'username') {
                return this.formatPhone.trim();
            }
            return this.formatPhone;
        },
        hasUnion() {
            let hasUnion = false;
            const skuList = this.pageInfo.skuList[this.categoryIndex].list;
            skuList.some(value => {
                if (value.type === 3) {
                    hasUnion = true;
                    return true;
                }
                return false;
            });
            return hasUnion;
        },
    },
    watch: {
        tjData(newData) {
            window.$sa_readtime['item_id'] = newData?.item_id;
            window.$sa_readtime['item_name'] = newData?.item_name;
        },
        isJobConvenienceAliMini: {
            handler(val) {
                if (val) {
                    window.localStorage.setItem('mini-appId', JobConvenienceAliMiniAppId);
                } else {
                    window.localStorage.removeItem('mini-appId');
                }
            },
            immediate: true,
        },
        productActiveObj: {
            handler(val) {
                this.isCurrentPaymentCycle = val.payment_cycle ? true : false;
                storage.set(keyConfig['isCurrentPaymentCycle'], val.payment_cycle ? 1 : 0);

                if (val.couponList && val.couponList.length) {
                    this.couponList = val.couponList.slice(0, 3);
                    setTimeout(() => this.setOverMask(), 50);
                } else {
                    this.couponList = [];
                }

                // ? GIO productView
                gioEvariableTrackOfPrivilege('productView', {
                    isNeedEntrance: true,
                    data: {
                        productId_var: this.id,
                        productName_var: this.pageInfo?.product?.name,
                        freeProduct_var: '否',
                        saleProduct_var: '否',
                        ...getUtmParams(false),
                    },
                });
            },
            deep: true,
        },
        productIndex(index) {
            this.currentCouponAmount = this.categoryDetailList[index]?.couponAmount || 0;
            this.currentRenewAmount = this.categoryDetailList[index]?.renewalReduceAmount || 0;
        },
        categoryIndex(index) {
            this.currentCouponAmount = this.pageInfo.skuList[index].list[0].couponAmount || 0;
            this.currentRenewAmount = this.pageInfo.skuList[index].list[0].renewalReduceAmount || 0;
        },
        newPrice(value) {
            if (this.shouldShowInApp) {
                this.getAllowance(parseFloat(value), this.newPrice);
            }
        },
        formatPhone(newValue, oldValue) {
            if (newValue.length < oldValue.length) {
                this.isDel = true;
            } else {
                this.isDel = false;
            }
        },
        /* isAuto(value) {
          if (value) {
              this.isDontShowShareBtn = true;
              this.generateNativeBtn();
          } else {
              this.isDontShowShareBtn = false;
          }
      }, */
    },
    methods: {
        handleCloseIcon() {
            this.isDontShowShareBtn = true;
        },
        handleGeneratedBtn() {
            if (this.isAuto) {
                window.zzc &&
                    window.zzc.call('base_navbarRightButtons', {
                        items: [],
                    });
            }
        },
        share() {
            this.$refs.share.onClickNavbarRight();
        },
        init(selectSkuId, visibile) {
            let self = this;

            localStorage.removeItem('selfTelephone'); // 清除状态
            localStorage.removeItem('tqczCurrentSpuInfo');

            let query = (this.query = this.parse_query_string(location.search.substring(1)));
            this.id = query.id;
            if (window.location.href.indexOf('withBar=0') > -1) this.showBarParams = false;

            if (query.account && !selectSkuId) {
                this.formatPhone = this.toFormatPhone(query.account);
            }
            if (self.isApp) {
                let phone = sessionStorage.getItem('phone');
                if (phone) {
                    self.formatPhone = phone;
                }

                self.paymentMethodData = [
                    {
                        type: 'ali',
                        title: '支付宝支付',
                        txt: '推荐有支付宝账户的用户使用',
                        check: true,
                        // iconUrl: 'https://imgcdn5.zuzuche.com/static/16/93/de0de065ac6a5c3c8a05a1f490f2e1be.png',
                        iconUrl:
                            'https://h5.chuxingyouhui.com/blackcard/shop/image/de0de065ac6a5c3c8a05a1f490f2e1be.png',
                    },
                    {
                        type: 'wechat',
                        title: '微信支付',
                        txt: '推荐有微信账户的用户使用',
                        check: false,
                        // iconUrl: 'https://imgcdn5.zuzuche.com/static/27/31/e888fc4de80d2e7bc325a2579ad03db2.png',
                        iconUrl:
                            'https://h5.chuxingyouhui.com/blackcard/shop/image/e888fc4de80d2e7bc325a2579ad03db2.png',
                    },
                ];

                // 判断是否出wechat原生支付
                if (!self.isGreaterVersion({ iosMinVersion: '1.3.0', androidMinVersion: '1.5.0' })) {
                    self.paymentMethodData = self.paymentMethodData.filter(data => {
                        if (data.type != 'wechat') {
                            return true;
                        }
                    });
                }
                //支付回调
                if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
                    zzc.on('visibilitychange', function(response) {
                        console.log(response);
                        if (response.hidden) {
                            self.isShowWxPayTip();
                        }
                    });
                } else {
                    self.isShowWxPayTip();
                }
            }

            storage.set('tqczCurrentSpuInfo', query);

            if (query.id) {
                this.getRechargeInfo(query.id, selectSkuId ? true : false).then(() => {
                    const currentSelectSkuId = selectSkuId || query.autoSelectSkuId;
                    if (currentSelectSkuId && this.pageInfo.skuList) {
                        let categoryIndex = -1;
                        let productIndex = -1;
                        let product = null;
                        this.pageInfo.skuList.forEach((skuList, index) => {
                            const { list } = skuList;
                            console.log(list);
                            if (!list) return;
                            list.forEach((item, i) => {
                                if (item.id === Number(currentSelectSkuId)) {
                                    categoryIndex = index;
                                    productIndex = i;
                                    product = item;
                                }
                            });
                        });
                        if (product) {
                            this.changeCategoryIndex(categoryIndex);
                            this.$nextTick(() => {
                                this.changeProductIndex(productIndex, product, visibile);
                            });
                            // 支付宝完成认证状态
                            this.checkVerifyCompleteStatus(query);
                        }
                    }
                });
                localStorage.setItem('tqczQueryId', query.id);
            } else {
                ZZCFL.Toast('页面参数有误，请重新尝试');
            }

            this.checkVerifyCancelStatus(query);
        },

        //倒计时
        timeDown({ time, handleEvent, dataExecution }) {
            let self = this;
            if (time == -1) {
                dataExecution();
                return;
            }
            let timeMunites = Math.floor(time / 60);
            let timeSeconds = Math.round(time - timeMunites * 60);
            let munitesNum = digitSplit(timeMunites);
            let secondsNum = digitSplit(timeSeconds);
            handleEvent({ secondsNum, munitesNum });
            setTimeout(function() {
                time--;
                self.timeDown({ time, handleEvent, dataExecution });
            }, 1000);

            function digitSplit(num) {
                let singleDigit;
                let tenDigit;
                let timeNum;
                if (num > 9) {
                    tenDigit = Math.floor(num / 10);
                    singleDigit = num - tenDigit * 10;
                } else {
                    tenDigit = 0;
                    singleDigit = num;
                }
                timeNum = String(tenDigit) + String(singleDigit);
                return timeNum;
            }
        },

        inputOnBlur() {
            focusLock = true;
            if (this.isInputClose) {
                this.isInputClose = false;
                setTimeout(() => {
                    this.showTips = true;
                });
            }
            setTimeout(() => {
                focusLock = false;
                this.isShowDel = false;
                this.showRechargeSuccessAccount = false;
                const el = document.querySelector('.btn-area');
                el.style.position = 'fixed';
            }, 200);
        },

        inputOnFocus(e) {
            if (!focusLock) {
                this.isShowDel = true;
                this.isError = false;
                this.showRechargeSuccessAccount = true;
                if (this.showTips) {
                    this.isInputClose = true;
                    this.showTips = false;
                }
                const el = document.querySelector('.btn-area');
                el.style.position = 'relative';
            } else {
                e.currentTarget.blur();
            }
        },
        inputOnInput(e) {
            let phone = e.target.value;
            const position = e.target.selectionStart;
            if (this.inputType === 'phone' || this.inputType !== 'username') {
                if (phone.includes(' ')) {
                    phone = phone.replace(/\s+/g, '');
                }
                if (this.inputType === 'qq') {
                    phone = phone.slice(0, 11);
                }
            }
            if (this.inputType === 'phone') {
                phone = this.toFormatPhone(phone).slice(0, 13);
            }

            this.formatPhone = phone;
            this.$nextTick(() => {
                if (this.inputType === 'phone') {
                    if (this.isDel) {
                        e.target.selectionStart = position;
                        e.target.selectionEnd = position;
                    } else {
                        if ([4, 9].includes(position)) {
                            e.target.selectionStart = position + 1;
                            e.target.selectionEnd = position + 1;
                        } else {
                            e.target.selectionStart = position;
                            e.target.selectionEnd = position;
                        }
                    }
                }
            });
        },
        dealButtonInputPosition(e) {
            if (this.isDel) {
                this.dealInputPosition(e);
            }
        },
        dealInputPosition(e) {
            const position = e.target.selectionStart;
            if (this.inputType === 'phone' && [4, 9].includes(position)) {
                setTimeout(() => {
                    e.target.selectionStart = position - 1;
                    e.target.selectionEnd = position - 1;
                }, 100);
            }
        },
        toFormatPhone(phone) {
            const arr = phone.split('');
            if (arr.length > 3) {
                arr.splice(3, 0, ' ');
            }
            if (arr.length > 8) {
                arr.splice(8, 0, ' ');
            }
            return arr.join('');
        },
        delInputStr() {
            this.formatPhone = '';
        },

        /**
         * 切换套餐子项目
         *
         * @param {*} index
         * @param {*} product
         */
        changeProductIndex(index, product, visibile) {
            // 会员状态秒杀sku不可点击
            if (product.stockStatus == 2 && product.type == 2) return;

            const shareHash = storage.get('shareHash');
            if (product.jump_url) {
                if (this.isNotMember) {
                    this.$refs.memberWall.triggerMemberPopup(true);
                    return;
                }
                // 避免返回立即触发跳转
                if (visibile) {
                    return;
                }
                location.href = `${product.jump_url}${shareHash ? `&shareHash=${shareHash}` : ''}`;
                return false;
            }

            this.productIndex = index;
            if (this.productActiveObj) this.lastProduct = this.productActiveObj;
            this.productActiveObj = product;

            if (product.signed_account) {
                this.signed_account = product.signed_account;
            } else if (this.lastProduct.signed_account) {
                this.signed_account = null;
            }

            this.showPriceTips = true;
            this.newPrice = parseFloat(product.unit_price);
            this.oldPrice = parseFloat(product.unit_price_old);
            this.renewPrice = parseFloat(product.actualRenewalPrice);
            this.priceAfterCoupon = parseFloat(product.bestPrice).toFixed(2);

            if (window.bigTj) {
                window.bigTj.track('click', {
                    obj_id: 'recharge_amount',
                    obj_type: 'recharge_detail',
                    ...this.tjData,
                });
                window.bigTj.track('click', {
                    obj_id: 'goods',
                    obj_type: 'recharge_detail',
                    business_type: 'recharge',
                    goods_id: product.id,
                    ...this.tjData,
                    ...flattenPrivilegeCategory(product.privilegeCategory),
                    cat_id: this.id,
                });
            }
            gioEvariableTrackOfPrivilege('rechargeSkuClick', {
                data: {
                    productName_var: this.pageInfo.product.name,
                    productSkuName_var: this.pageInfo.skuList[this.categoryIndex].list[this.productIndex].name,
                    productSkuid_var: this.pageInfo.skuList[this.categoryIndex].list[this.productIndex].sku_no,
                    productCategory_var: this.pageInfo.skuList[this.categoryIndex].category,
                    ...getUtmParams(false),
                },
            });
        },

        skuShowDataLog(sku) {
            return JSON.stringify({
                obj_id: 'goods',
                obj_type: 'recharge_detail',
                business_type: 'recharge',
                goods_id: sku.id,
                // ...this.tjData,
                ...flattenPrivilegeCategory(sku.privilegeCategory),
                cat_id: this.id,
            });
        },

        /**
         * 切换套餐
         *
         * @param {*} index
         */
        changeCategoryIndex(index) {
            this.categoryIndex = index;
            this.categoryDetailList = this.pageInfo.skuList[index]['list'];
            this.productIndex = this.categoryDetailList.findIndex(i => i.stockStatus == 1); // 找出第一个有库存的非秒杀sku
            if (this.productActiveObj) this.lastProduct = this.productActiveObj;
            this.productActiveObj = this.categoryDetailList[0];
            if (this.productActiveObj.signed_account) {
                this.signed_account = this.productActiveObj.signed_account;
            } else if (this.lastProduct.signed_account) {
                // 如果从有连续包月的账号，切换到其他非连续包月的规格，清除手机号
                this.signed_account = null;
            }
            this.newPrice = parseFloat(this.productActiveObj.unit_price);
            this.oldPrice = parseFloat(this.productActiveObj.unit_price_old);
            this.renewPrice = parseFloat(this.productActiveObj.actualRenewalPrice);
            this.priceAfterCoupon = parseFloat(this.productActiveObj.bestPrice).toFixed(2);

            window.bigTj &&
                window.bigTj.track('click', {
                    obj_id: 'recharge_type',
                    obj_type: 'recharge_detail',
                    ...this.tjData,
                    recharge_type_name: this.pageInfo?.skuList[this.categoryIndex]?.category,
                });

            gioEvariableTrackOfPrivilege('productCategoryClick', {
                data: {
                    productCategory_var: this.pageInfo.skuList[this.categoryIndex].category,
                    ...getUtmParams(false),
                },
            });
        },
        /**
         * 获取页面信息
         *
         * @param {*} id
         * @param {*} isRefresh 是否刷新数据 true 刷新 false 初始化
         */
        async getRechargeInfo(id, isRefresh) {
            let self = this;
            const { sourceChannel, channelId, channelToken } = self.query;
            let requestParams = { id, sourceChannel, channelId, channelToken };
            let result = await getRechargeInfoV2(requestParams); // TODO GIO miss brandName [API] 接口`${blackCardDomain}/recharge/detail` -> pageInfo -> product
            if (result.code === 0) {
                // if (result.data.redirect_url) location.href = result.data.redirect_url;
                self.pageInfo = result.data;
                // ? GIO 充值 - 浏览充值支付页
                gioEvariableTrackOfPrivilege('depositPageView', {
                    isNeedEntrance: true,
                    data: {
                        productId_var: id,
                        // thirdBusinessType_var: self.pageInfo?.product?.name,
                        productName_var: self.pageInfo?.product?.name,
                        productType_var: self.pageInfo?.product?.category,
                    },
                });

                if (result.data.skuList && result.data.skuList.length > 0) {
                    // 已签约的不显示规格
                    let skuMaplist = [];

                    for (let i = 0; i < result.data.skuList.length; i++) {
                        let sku = result.data.skuList[i];
                        let skufilter = [];
                        let signed_account = '';
                        if (sku.list && sku.list.length > 0) {
                            for (let j = 0; j < sku.list.length; j++) {
                                if (sku.list[j].signed_account) {
                                    // 判断是否有连续包月的, 记录下来，for tips
                                    if (!signed_account) signed_account = sku.list[j].signed_account;
                                } else {
                                    // 连续包月不展示sku
                                    if (sku.list[j].channel_show != 4) skufilter.push(sku.list[j]);
                                }
                            }
                        }

                        sku.list = skufilter;
                        sku.signed_account = signed_account;
                        if (skufilter && skufilter.length > 0) {
                            skuMaplist.push(sku);
                        }
                    }

                    result.data.skuList = skuMaplist;

                    self.categoryDetailList = result.data.skuList[0]['list'];

                    self.productActiveObj = self.categoryDetailList.find(i => i.stockStatus == 1);

                    if (self.productActiveObj.signed_account) {
                        self.signed_account = self.productActiveObj.signed_account;
                    }

                    let isAuto = false; // 是否显示常见问题s
                    result.data.skuList.forEach(sku => {
                        sku &&
                            sku.list.forEach(
                                /**
                                 * @param {{ payment_cycle: number }} item
                                 */
                                item => {
                                    const paymentCycle = Number(item.payment_cycle);
                                    if (paymentCycle === 1 || paymentCycle === 2) {
                                        isAuto = true;
                                    }
                                }
                            );
                    });

                    if (isAuto == true) {
                        this.isAuto = true;
                    }

                    self.showPriceTips = true;
                    self.newPrice = parseFloat(self.productActiveObj.unit_price);
                    self.oldPrice = parseFloat(self.productActiveObj.unit_price_old);
                    self.renewPrice = parseFloat(self.productActiveObj.actualRenewalPrice);
                    self.currentCouponAmount = self.productActiveObj.couponAmount || 0;
                    self.currentRenewAmount = self.productActiveObj.currentRenewAmount || 0;
                    self.priceAfterCoupon = parseFloat(self.productActiveObj.bestPrice).toFixed(2);
                    self.categoryIndex = isRefresh ? self.categoryIndex || 0 : 0;
                    self.productIndex = self.categoryDetailList.findIndex(i => i.stockStatus == 1); // 找出第一个有库存的非秒杀sku
                }

                // self.paymentMethodData = result.data.app_pay_list;
                let product = result.data.product;
                if (product) {
                    self.inputType = product.inputType;
                    self.orderLink = product.orderLink;
                    self.submitName = product.submitName;
                    self.isSpecial = result.data.customPhoneList && result.data.customPhoneList.length > 1;
                    self.trackPageName = product.name;
                    self.tipsImage = product.purchase_notes_img;
                    // Pv统计
                    window.bigTj.track('page_view', {
                        obj_id: 'recharge_detail',
                        obj_type: 'recharge_detail',
                        privilege_id: this.query.id,
                        privilege_name: this.trackPageName,
                        item_id: this.id,
                        item_name: this.pageInfo?.product?.name,
                        item_type: result.data?.product?.status == 2 ? 1 : 0,
                        ab_test_json: {
                            bwbtAllowance: this.abTestIsBValue,
                        },
                    });
                    if (this.shouldShowInApp) {
                        shoppingUbsidyTipShowTrack({
                            abTestIsBValue: this.abTestIsBValue,
                            tjData: this.tjData,
                        });
                    }
                }

                self.customPhone = result.data.custom_phone || '4000233086';
                self.customPhoneFormat = self.customPhone.replace(/(\d{3})(\d{3})/, '$1 $2 ');
                self.customPhoneList = result.data.customPhoneList || [];
                // 优酷使用自营在线客服
                if (this.isAuto) {
                    localStorage.setItem('tqczSelfService', 1); // 传递给后面的页面
                    self.customPhoneList = [];
                } else {
                    localStorage.removeItem('tqczSelfService');
                }
                // 显示租租车电话
                if (self.query.selfTelephone == 1) {
                    self.customPhoneList = [];
                    self.customPhone = '1010-0118';
                }

                // 存储电话列表到LS 为了客服页也能打电话
                let phone = self.customPhoneList.length == 0 ? [self.customPhone] : self.customPhoneList;
                window.sessionStorage.setItem('customPhoneList', JSON.stringify(phone));

                self.isStopSale = result.data.product.status == 2;

                if (self.submitName) {
                    self.submitText = self.submitName;
                    /* self.getCouponBuyText = self.submitName; */
                } else if (!self.pageInfo.product.placeholder) {
                    self.submitText = '立即购买';
                }

                // this.uniPay = new uniPayClass({
                //     business: 'video',
                //     getOrderData: () => {
                //         return new Promise(async (resolve, reject) => {
                //             let result = await saveSkuIdV2({
                //                 sku_id: this.productActiveObj.id,
                //                 account: this.phone,
                //                 ...this.query,
                //             });

                //             if (result.code === 0 && result.data) {
                //                 self.setStorage(result.data.orderId, result.data.successUrl);
                //                 resolve(result.data);
                //             } else {
                //                 ZZCFL.Toast(result.msg);
                //                 reject();
                //             }
                //         });
                //     },
                //     onPaySuccess: () => {
                //         console.log('成功啦~');
                //         this.paySuccess();
                //     },
                // });
            } else if (result.code === 4009) {
                // 针对审核账户
                ZZCFL.Dialog(
                    {
                        title: '很抱歉，本客户端无法为您提供此项服务',
                        showCancelButton: false,
                        confirmButtonText: '返回首页',
                    },
                    () => {
                        if (env.isApp) {
                            nativeApi.goHome();
                        } else {
                            window.location.href = '/new/#/home';
                        }
                    }
                );
            } else {
                ZZCFL.Toast(result.msg);
            }
        },

        /**
         * 显示客服弹窗
         *
         * @date 2019-10-16
         * @returns
         */
        showService() {
            if (this.customPhoneList.length == 1 && this.customPhoneList[0].phone) {
                location.href = 'tel:' + this.customPhoneList[0].phone;
                return false;
            }
            // 畅由输出的直接跳转到他们的客服链接
            if (this.isCY) {
                window.location.href = getGDMobileServiceUrl();
                this.emitTrack();
                return true;
            }
            this.isShowService = true;
            this.emitTrack();
            return true;
        },

        /**
         * 是否ios
         *
         * @returns
         */
        is_iOS() {
            var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            return iOS;
        },

        /**
         * 获取路由query参数
         *
         * @param {*} query
         * @returns
         */
        parse_query_string(query) {
            var vars = query.split('&');
            var query_string = {};
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                var key = decodeURIComponent(pair[0]);
                var value = decodeURIComponent(pair[1]);
                // If first entry with this name
                if (typeof query_string[key] === 'undefined') {
                    query_string[key] = decodeURIComponent(value);
                    // If second entry with this name
                } else if (typeof query_string[key] === 'string' && query_string[key] !== decodeURIComponent(value)) {
                    var arr = [query_string[key], decodeURIComponent(value)];
                    query_string[key] = arr;
                    // If third or later entry with this name
                } else if (Array.isArray(query_string[key])) {
                    query_string[key].push(decodeURIComponent(value));
                }
            }
            return query_string;
        },

        //选择支付方式
        onCheckPaymentMethod(index) {
            let self = this;
            let paymentMethodData = self.paymentMethodData;
            if (!paymentMethodData[index].check) {
                for (let i = 0; i < paymentMethodData.length; i++) {
                    if (i == index) {
                        paymentMethodData[i].check = true;
                    } else {
                        paymentMethodData[i].check = false;
                    }
                }
            }
            self.paymentMethodData = paymentMethodData;
        },

        /**
         * app询问支付弹窗
         *
         */
        showWxPayTips() {
            let self = this;
            ZZCFL.Dialog(
                {
                    title:
                        '请确认支付是否已完成，如果在支付过程中遇到问题请点击“重新支付”，如果已经成功支付请点击“已完成支付”',
                    showCancelButton: true,
                    closeOnClickModal: false,
                    confirmButtonText: '已完成支付',
                    cancelButtonText: '重新支付',
                },
                async value => {
                    /**
                     * 按钮点中后的回调
                     * @param  {[string]} value [description]
                     * @return {[string]} 返回confirm  || cancel [description]
                     */

                    if (value === 'confirm') {
                        let result = await getOrderPayStatus({ order_id: localStorage.getItem('order_id') });
                        if (result.code == 0) {
                            self.paySuccess();
                        } else {
                            ZZCFL.Toast('您的订单未完成支付，请重新操作');
                        }
                    }

                    ZZCFL.Utils.Storage.setItem('isCheckPay', 'false');
                }
            );
        },

        /**
         * app 是否显示询问已支付弹窗
         *
         */
        isShowWxPayTip() {
            let self = this;
            let isCheckPay = ZZCFL.Utils.Storage.getItem('isCheckPay') || 'false';
            if (isCheckPay == 'true') {
                self.showWxPayTips();
                self.checkPay();
            }
        },

        /**
         * app 支付是否成功轮询
         *
         */
        checkPay() {
            let self = this;
            payTimer = setTimeout(async () => {
                let result = await getOrderPayStatus({ order_id: localStorage.getItem('order_id') });
                if (result.code == 0) {
                    clearTimeout(payTimer);
                    self.paySuccess();
                } else if (result.code == 2) {
                    self.checkPay();
                } else {
                    ZZCFL.Utils.Storage.setItem('isCheckPay', 'false');
                    clearTimeout(payTimer);
                }
            }, 1000);
        },

        /**
         * app环境下支付
         *
         */
        // async onAppPay() {
        //     let self = this;
        //     let paymentMethodData = self.paymentMethodData;
        //     let payType;
        //     let result;
        //     // let num;
        //     for (let i = 0; i < paymentMethodData.length; i++) {
        //         if (paymentMethodData[i].check) {
        //             // num = i;
        //             payType = paymentMethodData[i].type;
        //         }
        //     }
        //     self.appPayType = payType;

        //     //支付方式
        //     switch (self.appPayType) {
        //         case 'wechat':
        //             result = await saveSkuIdV2({
        //                 sku_id: self.productActiveObj.id,
        //                 account: self.phone,
        //                 ...self.query,
        //             });

        //             if (result.code == 0) {
        //                 // 判断是否可以调起原生app微信支付
        //                 //调起原生支付宝支付接口
        //                 self.setStorage(result.data.order_id, result.data.success_url);

        //                 self.payControl({
        //                     result,
        //                     type: 'wechat',
        //                     payType: 'recharge',
        //                 });
        //                 console.log('当前版本大于1.3.0/1.5.0，准备开始调起微信app支付');
        //             } else {
        //                 ZZCFL.Toast(result.msg);
        //             }

        //             break;
        //         case 'ali':
        //             //检测是否安装支付宝
        //             result = await saveSkuIdV2({
        //                 sku_id: self.productActiveObj.id,
        //                 account: self.phone,
        //                 ...self.query,
        //             });

        //             if (result.code === 0) {
        //                 //调起原生支付宝支付接口
        //                 self.setStorage(result.data.order_id, result.data.success_url);

        //                 self.payControl({
        //                     result,
        //                     type: 'ali',
        //                     payType: 'recharge',
        //                 });
        //             } else {
        //                 ZZCFL.Toast(result.msg);
        //             }

        //             break;
        //     }
        // },

        /**
         * 调起支付
         *
         * @date 2019-06-12
         * @param {*} { result, type, payType } payType(card,recharge,hero三个参数之一)
         */
        async payControl({ result, type, payType }) {
            let appInfoTyoe, appCallType;
            if (type == 'ali') {
                appInfoTyoe = 'alipayApp';
                appCallType = 'pay_startAliPay';
            } else {
                appInfoTyoe = 'weixinApp';
                appCallType = 'pay_startWechatPay';
            }

            if (window.zzcjsbridge.nativePay) {
                try {
                    let appInfo = await getAppPayInfo({
                        order_id: result.data.order_id,
                        app: appInfoTyoe,
                        type: payType,
                    });

                    if (appInfo.code == 0) {
                        zzc.call('nativePay', {
                            channel: result.data.pay_channel,
                            type: appInfoTyoe,
                            data: appInfo.data.pay_str,
                            url: appInfo.data.url,
                            success: res => {
                                console.log('调起支付插件回调------: ', res);
                            },
                        });
                    } else {
                        ZZCFL.Toast(appInfo.msg);
                    }
                } catch (error) {
                    ZZCFL.Toast('网络错误~请稍后重试');
                }
            } else {
                zzc.call(appCallType, {
                    orderSN: result.data.order_id,
                    channel: result.data.pay_channel,
                    payId: result.data.pay_id,
                    success: function(rs) {
                        console.log(rs);
                        self.setStorage(result.data.order_id, result.data.success_url);
                    },
                });
            }
        },

        //判断是否使用微信app支付
        //iosMinVersion 最低兼容版本 格式1.3.0
        //androidMinVersion 最低兼容版本 格式1.5.0
        isGreaterVersion({ iosMinVersion, androidMinVersion }) {
            let minVersion;
            let ua = window.navigator.userAgent;
            let isIos = /ZZCIOS\/black/.test(ua);
            let isAndroid = /ZZCAndroid\/black/.test(ua);
            if (isIos) {
                minVersion = iosMinVersion;
            } else if (isAndroid) {
                minVersion = androidMinVersion;
            } else {
                return false;
            }
            let minVersionArray = minVersion.split('.');
            let versionArray =
                ua
                    .split('(')[0]
                    .split('/')[2]
                    .split('.') || [];
            if (Number(versionArray[0]) > minVersionArray[0]) {
                return true;
            } else if (Number(versionArray[1]) >= minVersionArray[1]) {
                return true;
            } else {
                return false;
            }
        },

        /**
         * 缓存订单id和回调链接
         *
         * @param {*} id
         * @param {*} url
         */
        setStorage(id, url) {
            if (id) localStorage.setItem('order_id', id);
            if (url) localStorage.setItem('success_url', url);
        },

        /**
         * 支付成功跳转链接
         *
         * @param {*} url
         */
        paySuccess(url) {
            ZZCFL.Utils.Storage.setItem('isCheckPay', 'false');
            if (url) location.href = url;
            location.href = localStorage.getItem('success_url');
        },

        /**
         * 跳转至订单列表
         *
         */
        linkToDetail() {
            // Pv统计
            window.bigTj &&
                window.bigTj.track('click', {
                    obj_id: 'recharge_detail_order',
                    obj_type: 'recharge_detail',
                    privilege_id: this.query.id,
                    privilege_name: this.trackPageName,
                    ...this.tjData,
                });

            OrderListGrayScale.goOrderList('priv_rechargeNormal');
        },

        emitTrack() {
            // Pv统计
            window.bigTj.track('click', {
                obj_id: 'customer_service_button',
                obj_type: 'recharge_detail',
                privilege_id: this.query.id,
                privilege_name: this.trackPageName,
                ...this.tjData,
            });
        },

        /**
         * 非app环境下支付
         *
         * @returns
         */
        async submit() {
            if (this.query.id === '75' && window.monitor && typeof window.monitor.report === 'function') {
                // 新浪微博的商品打个日志
                window.monitor.report({
                    level: 'info',
                    url: window.location.href,
                    msg: 'tqcz submit sku data: ' + JSON.stringify(this.productActiveObj),
                });
            }

            let self = this;

            if (this.productActiveObj.jump_url) {
                location.href = this.productActiveObj.jump_url;
                return false;
            }

            if (this.query.selfTelephone) localStorage.setItem('selfTelephone', 1);
            // ? GIO 充值 - 点击立即购买
            gioEvariableTrackOfPrivilege('clickBuy', {
                data: {
                    productId_var: this.tjData?.spu_id,
                    freeProduct_var: '否',
                    saleProduct_var: '否',
                    productName_var: self.pageInfo?.product?.name,
                    productType_var: self.pageInfo?.product?.category,
                    ...getUtmParams(false),
                },
            });
            // Pv统计
            window.bigTj.track('click', {
                obj_id: 'immediate_recharge_button',
                obj_type: 'recharge_detail',
                privilege_id: this.query.id,
                privilege_name: this.trackPageName,
                recharge_amount: this.productActiveObj.bestPrice,
                ...this.tjData,
            });

            // 停止售卖
            if (this.isStopSale) {
                ZZCFL.Toast('优惠已抢光啦～我们会尽快补货');
                return false;
            }

            if (this.pageInfo.product.placeholder) {
                if (!this.phone && !this.signed_account) {
                    if (this.inputType == 'phone') {
                        ZZCFL.Toast('请输入手机号码');
                        this.errorTips = '请输入手机号码';
                    } else if (this.inputType == 'username' && this.pageInfo.product.placeholder) {
                        ZZCFL.Toast(this.pageInfo.product.placeholder);
                        this.errorTips = this.pageInfo.product.placeholder;
                    } else {
                        ZZCFL.Toast('请输入QQ号码');
                        this.errorTips = '请输入QQ号码';
                    }
                    this.isError = true;
                    return false;
                }

                let number = this.signed_account || this.phone;
                if (this.inputType == 'phone') {
                    if (number.length < 11) {
                        ZZCFL.Toast('手机号格式不对');
                        this.errorTips = '手机号格式不对';
                        this.isError = true;
                        return false;
                    }
                }

                const shouldJump = await this.checkStudentVerify();
                console.log(shouldJump, 'shouldJump');
                if (!shouldJump) return;
                if (this.productActiveObj.payment_cycle > 0 && !this.isCheckAutoRule) {
                    this.$toast('请先阅读并同意协议');
                    this.showRuleAnimation = true;
                    return false;
                }
                if (this.gameForm && this.gameForm.length) {
                    const err = await this.validateForm();
                    if (err) {
                        this.$toast(err);
                        return false;
                    }
                }

                if (this.productActiveObj.activity_sku_id > 0 || this.productActiveObj.is_activity == 1) {
                    try {
                        await this.getRechargeActivityVerify();
                    } catch (error) {
                        console.log('error: ', error);
                        return false;
                    }
                }

                localStorage.setItem('SHOP-TQCZ__tjData', JSON.stringify(this.tjData));
                if (self.currentCouponAmount) {
                    // ? GIO 充值 - 立即下单（重新下单）
                    gioEvariableTrackOfPrivilege('buyNow', {
                        data: {
                            freeProduct_var: '否',
                            saleProduct_var: '否',
                            productName_var: self.pageInfo?.product?.name,
                            productId_var: this.tjData?.spu_id,
                            ...getUtmParams(false),
                        },
                    });
                    self.autoGetCoupon();
                } else {
                    self.newPayControll();
                }
            } else {
                if (this.isApp && this.isDiscountForStudent) return;
                self.newPayControll();
            }
        },

        /**
         * 关闭客服弹窗
         *
         * @date 2019-05-07
         */
        closeService() {
            this.isShowService = false;
        },

        async newPayControll(code, text) {
            const productActiveObj = this.productActiveObj;
            // business 字段变更 -> paymentBusiness
            const business = productActiveObj.paymentBusiness || 'video';
            const gameForm = this.flatedGameForm
                .filter(el => el.value)
                .map(el => {
                    return {
                        label: el.label,
                        keyName: el.keyName,
                        value: el.value,
                    };
                });
            // eslint-disable-next-line no-unused-vars
            const { account, ...queryItem } = this.query || {};
            let param = {
                sku_id: this.productActiveObj.id, // sku id
                phone: this.signed_account || this.phone, // 充值号码
                isAuto: productActiveObj.payment_cycle > 0, // 是否连续包月 0 不是 1 微信 2 支付宝
                paymentCycle: productActiveObj.payment_cycle,
                business, // 业务类型
                gameForm,
                inputType: this.inputType,
                confirmTips: this.productActiveObj.confirm_tips,
                render: {
                    list: [
                        {
                            key: '规格',
                            value: this.productActiveObj.spec_name || this.productActiveObj.spec,
                        },
                    ], // 购买规格
                    goods: [
                        {
                            name: this.productActiveObj.name,
                            price: this.productActiveObj.unit_price,
                            oldPrice: this.productActiveObj.unit_price_old,
                            category: this.productActiveObj.category,
                            logo: this.pageInfo.product.logo,
                            renewPrice: {
                                amount: this.productActiveObj.renewalReduceAmount || 0,
                                price: this.productActiveObj.actualRenewalPrice || 0,
                            },
                        },
                    ], // 商品类型
                },
                option: {
                    ...queryItem,
                },
            };
            localStorage.setItem('blackUniqueCommonPayParam', JSON.stringify(param));
            // 增加判断如果是学生商品增加跳转参数
            if (this.isApp && this.isDiscountForStudent && this.alipayVerifySuccess) {
                this.alipayVerifySuccess = false;
                location.href = `${location.origin}/new/tqcz/pay/pay.html?t=${new Date().getTime()}&couponCode=${code}${
                    code == 110 ? `&msg=${text}` : ''
                }&business=${business}&ZZCAppArg=appopenpage,topbar_remove&alipayStudentSuccess=${1}`;
                return;
            }
            location.href = `${location.origin}/new/tqcz/pay/pay.html?t=${new Date().getTime()}&couponCode=${code}${
                code == 110 ? `&msg=${text}` : ''
            }&business=${business}&ZZCAppArg=appopenpage,topbar_remove`;
        },

        linkToQue() {
            // location.href = `${location.origin}/new/tqcz/rule/index.html`;
            location.href = 'https://m.black-unique.com/slime/pages/600/index.html';
        },
        openCouponList() {
            this.isShowCouponList = true;
        },

        // 不用前端去调接口获取了，sku列表接口返回了
        /* async getDetailCoupon() {
          const res = await api.cardGetDetailCoupon({
              type: 'recharge',
              skuId: this.productActiveObj.id,
              all: 1,
          });
          if (res.code !== 0) return;
          const couponList = res.data;
          this.couponList = couponList.slice(0, 3);
          setTimeout(() => this.setOverMask(), 50);
      }, */

        setOverMask() {
            const dom = this.$refs.coupon;
            this.showOverMask = dom ? dom.scrollWidth > dom.offsetWidth : false;
        },
        generateNativeBtn() {
            /* setTimeout解决安卓不显示的bug */
            setTimeout(() => {
                window.zzc &&
                    window.zzc.call('base_navbarRightButtons', {
                        items: this.is_iOS() ? [{ text: '常见' }, { text: '问题' }] : [{ text: `常见问题     ` }],
                    });
                window.zzc &&
                    window.zzc.on('app:navbarRightButtonsClick', () => {
                        this.linkToQue();
                    });
            }, 500);
        },

        getRechargeActivityVerify() {
            return new Promise((resolve, reject) => {
                let skuId = null;
                let isActivity = this.productActiveObj.is_activity == 1;
                if (isActivity) {
                    skuId = this.productActiveObj.id;
                } else {
                    skuId = this.productActiveObj.activity_sku_id;
                }
                getRechargeActivityVerify({
                    skuId: skuId,
                    account: this.signed_account || this.phone,
                })
                    .then(async res => {
                        // if (res.code == 0) {
                        //     if (isActivity) {
                        //         if (res.data.useable) {
                        //             resolve();
                        //         } else {
                        //             ZZCFL.Toast(res.data.msg);
                        //             reject();
                        //         }
                        //         return false;
                        //     }
                        //     if (res.data.useable && res.data.sku) {
                        //         this.showCouponPop = true;
                        //         this.couponSku = res.data.sku;
                        //         // Pv统计
                        //         window.bigTj.track('page_view', {
                        //             obj_id: 'iqy_popup_windows',
                        //             obj_type: 'iqy_popup_windows',
                        //             privilege_id: this.query.id,
                        //             privilege_name: this.trackPageName,
                        //         });
                        //         this.couponResolve = {
                        //             sku: res.data.sku,
                        //             resolve,
                        //         };
                        //         // this.productActiveObj = res.data.sku;
                        //         return false;
                        //     }
                        // }
                        // resolve();

                        if (res.code == 0) {
                            let relationSku = res.data.sku;

                            if (isActivity) {
                                this.popImg = this.productActiveObj.activity_popup_img;
                                // 付款后验证
                                if (this.productActiveObj.activity_verify_method == 2) {
                                    resolve();
                                    return false;
                                }
                                // 当前是活动sku
                                switch (this.productActiveObj.activity_popup_display_method) {
                                    case 0: // 不出弹窗
                                        if (res.data.useable) {
                                            // TODO: 购买
                                            resolve();
                                        } else {
                                            // TODO: 不可购买
                                            ZZCFL.Toast(res.data.msg);
                                            reject();
                                        }
                                        break;
                                    case 1: //符合资格出弹窗
                                        if (res.data.useable) {
                                            // TODO: 出弹窗,确认购买
                                            this.isShowSecPop = true;
                                            this.couponResolve = {
                                                sku: res.data.sku,
                                                resolve,
                                                reject,
                                            };
                                            return false;
                                        } else {
                                            ZZCFL.Toast(res.data.msg);
                                            reject();
                                        }
                                        break;
                                    case 2: // 不符合资格出弹窗
                                        if (res.data.useable) {
                                            resolve();
                                        } else {
                                            this.isShowFirstPop = true;
                                            this.couponResolve = {
                                                sku: res.data.sku,
                                                resolve,
                                                reject,
                                            };
                                            return false;
                                        }
                                        break;
                                }
                            } else if (relationSku) {
                                this.popImg = relationSku.activity_popup_img;
                                if (relationSku.activity_verify_method == 1) {
                                    switch (relationSku.activity_popup_display_method) {
                                        case 0:
                                            if (res.data.useable) {
                                                // TODO: 替换为活动sku
                                                this.productActiveObjTemp = this.productActiveObj;
                                                this.productActiveObj = relationSku;
                                                resolve();
                                            } else {
                                                // TODO: 不替换
                                                resolve();
                                            }
                                            break;
                                        case 1:
                                            if (res.data.useable) {
                                                // TODO: 出弹窗,替换为活动sku
                                                this.isShowSecPop = true;
                                                this.couponResolve = {
                                                    sku: res.data.sku,
                                                    resolve,
                                                };
                                                return false;
                                            } else {
                                                // TODO: 不替换
                                                resolve();
                                            }
                                            break;
                                        case 2:
                                            if (res.data.useable) {
                                                // TODO: 替换为活动sku
                                                this.productActiveObjTemp = this.productActiveObj;
                                                this.productActiveObj = relationSku;
                                                resolve();
                                            } else {
                                                resolve();
                                            }

                                            break;
                                    }
                                } else if (relationSku.activity_verify_method == 2) {
                                    // 付款后验证
                                    // TODO: 替换为活动sk
                                    this.productActiveObjTemp = this.productActiveObj;
                                    this.productActiveObj = relationSku;
                                }
                            }
                        } else if ([112, 100].includes(res.code)) {
                            // 这个情况提示用户，不能往下走
                            ZZCFL.Toast(res.msg);
                            return;
                        }
                        resolve();
                    })
                    .catch(() => {
                        resolve();
                    });
            });
        },

        // 使用优惠
        submitDiscount() {
            // Pv统计
            window.bigTj.track('click', {
                obj_id: 'acquire_discount_iqy',
                obj_type: 'iqy_popup_windows',
                privilege_id: this.query.id,
                privilege_name: this.trackPageName,
            });
            this.productActiveObjTemp = this.productActiveObj;
            this.productActiveObj = this.couponResolve.sku;
            this.couponResolve.resolve();
            this.showCouponPop = false;
        },

        // 放弃使用活动优惠
        cancelDiscount() {
            // Pv统计
            window.bigTj.track('click', {
                obj_id: 'give_up_iqy',
                obj_type: 'iqy_popup_windows',
                privilege_id: this.query.id,
                privilege_name: this.trackPageName,
            });
            this.couponResolve.resolve();
            this.showCouponPop = false;
        },

        firstPopSubmit() {
            this.couponResolve.reject();
            this.isShowFirstPop = false;
        },

        secPopSubmit() {
            this.productActiveObjTemp = this.productActiveObj;
            this.productActiveObj = this.couponResolve.sku;
            this.couponResolve.resolve();
            this.isShowSecPop = false;
        },

        secPopCancel() {
            if (this.couponResolve.reject && this.productActiveObj.is_activity == 1) {
                this.couponResolve.reject();
            } else {
                this.couponResolve.resolve();
            }
            this.isShowSecPop = false;
        },

        finishTimedown() {
            this.renewBuyInfo = null;
            this.getRechargeInfo(this.query.id);
            // this.getDetailCoupon();
        },
        /* item如有couponAmount 则请求自动领券 */
        autoGetCoupon() {
            if (this.isSourceChannel) {
                this.newPayControll();
                return;
            }

            const obj = {
                type: 'recharge',
                skuId: this.productActiveObj.id,
                orderAmount: Number(this.productActiveObj.unit_price).toFixed(2),
                buyNum: 1,
            };

            getAutoPickCoupon(obj)
                .then(res => {
                    if (res.code == 0 && res.data.code == 0) {
                        this.newPayControll(res.code);
                        return;
                    } else if (res.code == 210006) {
                        this.newPayControll(110, res.msg);
                        return;
                    }
                    this.newPayControll();
                })
                .catch(() => {
                    this.newPayControll();
                });
        },

        handleIsNotMember(isNotMember) {
            this.isNotMember = isNotMember;
        },
        //补贴金提示点击
        handleTrackClick() {
            shoppingUbsidyTipClickTrack({ abTestIsBValue: this.abTestIsBValue, tjData: this.tjData });
        },
        // autoRulePopClickHandle() {
        //     this.isCheckAutoRule = true;
        //     this.showAutoRulePop = false;
        //     this.submit();
        // },
    },
    filters: {
        formatPrice(v) {
            return parseFloat(Number(v).toFixed(2));
        },
        price(num) {
            if (typeof num !== 'number') num = parseFloat(num);
            if (Number.isNaN(num)) return '';
            return num.toFixed(2);
        },
        needFloatPrice(v) {
            return Number(v).toFixed(2);
        },
    },
};
